import {useEffect, useRef, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {WorkflowLoading, WorkflowError} from './containerApp/LoanWorkflowGuard';
import {useAuth} from '../../../config/AuthProvider/authProvider';
import {ApiResultModel} from '../../../models/common.model';
import {IGetInProgressLoanTemplateResponse} from '../../../models/loan.model';
import {GetInProgressLoanTemplate} from '../../../services/loan.service';
import ContainerRegisterLoan from './containerApp/containerApp';
import LoanDetail from './loanDetail/loanDetail';
import InstallmentChequeContainer from './Loans/cheques/installmentChequeContainer';
import InstallmentsContainer from './Loans/cheques/installmentsContainer';
import Loans from './Loans/loans';
import {
    Navigate,
    Route,
    Routes,
    useNavigate,
    useLocation,
} from 'react-router-dom';

export default function LoansContainer({
    setTabChild,
}: {
    setTabChild: (id: number) => void;
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const {setRefKey} = useAuth();
    const [entryReady, setEntryReady] = useState(false);
    const [entryError, setEntryError] = useState(false);
    const entryParams = useRef(new URLSearchParams(window.location.search));
    const mounted = useRef(false);
    const cleanUrl = () => {
        // Search parameters are outside HashRouter. Preserve its current hash.
        window.history.replaceState(
            window.history.state,
            '',
            window.location.pathname + window.location.hash
        );
    };
    const {mutate: resolveEntry} = useMutation(GetInProgressLoanTemplate, {
        onSuccess: (
            result: ApiResultModel<IGetInProgressLoanTemplateResponse>
        ) => {
            if (!mounted.current) return;
            if (!result.isSuccess) {
                setEntryError(true);
                return;
            }
            const loan = result.data;
            if (loan?.hasMany) {
                navigate('/loans', {replace: true});
            } else if (loan?.referenceKey) {
                setRefKey(loan.referenceKey);
                navigate('/loans/request', {replace: true});
            } else {
                setRefKey(null);
                navigate('/loans/request/confirmLoanTemplate', {replace: true});
            }
            cleanUrl();
            setEntryReady(true);
        },
        onError: () => {
            if (mounted.current) setEntryError(true);
        },
    });
    const startEntry = () => {
        setEntryError(false);
        const params = entryParams.current;
        const target = params.get('target');
        const loanTemplateKey = params.get('loanTemplateKey');
        if (target?.includes('registerLoan')) {
            setRefKey(null);
            navigate('/loans/request', {replace: true});
            cleanUrl();
        } else if (target?.includes('requestLoan') && loanTemplateKey) {
            queryClient.setQueryData('LOAN_TEMPLATE_KEY', loanTemplateKey);
            resolveEntry({loanTemplateKey});
            return;
        } else if (location.pathname === '/loans') {
            let inProgress = false;
            try {
                inProgress = !!JSON.parse(
                    sessionStorage.getItem('HAS_INPROGRESS') || 'null'
                )?.inProgress;
            } catch {}
            if (inProgress) navigate('/loans/request', {replace: true});
        }
        setEntryReady(true);
    };
    useEffect(() => {
        mounted.current = true;
        startEntry();
        document
            .querySelector('meta[name="theme-color"]')
            ?.setAttribute('content', '#fff');
        return () => {
            mounted.current = false;
        };
    }, []);
    if (entryError) return <WorkflowError retry={startEntry} />;
    if (!entryReady) return <WorkflowLoading />;

    return (
        <div>
            <Routes>
                <Route index element={<Loans />} />
                <Route path="detail/*" element={<LoanDetail />} />
                <Route
                    path="request/*"
                    element={
                        <ContainerRegisterLoan
                            setTabChild={setTabChild}
                            refKey=""
                        />
                    }
                />
                <Route
                    path="installments/*"
                    element={<InstallmentsContainer />}
                />
                <Route
                    path="installmentCheques/*"
                    element={<InstallmentChequeContainer />}
                />
                <Route
                    path="register"
                    element={
                        <Navigate
                            to="/loans/request/createNewRequest"
                            replace
                        />
                    }
                />
                <Route path="*" element={<Navigate to="/loans" replace />} />
            </Routes>
        </div>
    );
}
